import React from 'react'
import PropTypes from 'prop-types'
import Alert from '@vtex/styleguide/lib/Alert'

const defaultWebHookNotification = ({ error, message }) => {
  return (
    <div>
      {error ? (
        <Alert type="warning">{error}</Alert>
      ) : (
        <Alert type="success">{message}</Alert>
      )}
    </div>
  )
}

defaultWebHookNotification.propTypes = {
  message: PropTypes.string,
  error: PropTypes.string,
}

export default defaultWebHookNotification
